export function sliderIngredients() {

  $(".slider-ingredients").slick({
    dots: true,
    appendDots: $('.dots'),
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    mobileFirst: true,
    prevArrow: $(".holder-slider-ingredients .common-slider-controls .prev-arrow"),
    nextArrow: $(".holder-slider-ingredients .common-slider-controls .next-arrow"),
    responsive: [
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        }
      }
    ]
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/slider-ingredients.js